<template>
  <v-dialog :model-value="modelValue" max-width="400"
    @update:model-value="$emit('update:modelValue', $event)">
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon :color="iconColor" size="24" class="mr-3">
          {{ icon }}
        </v-icon>
        <span class="text-h6">{{ title }}</span>
      </v-card-title>

      <v-card-text class="pb-0">
        <p class="text-body-1">{{ text }}</p>

        <slot />
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn variant="text" :disabled="loading" @click="handleCancel">
          {{ cancelText }}
        </v-btn>
        <v-btn :color="confirmColor" :loading="loading" @click="handleConfirm">
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  title: {
    type: String,
    default: 'Confirmar Ação'
  },
  text: {
    type: String,
    default: 'Tem certeza que deseja continuar?'
  },
  confirmText: {
    type: String,
    default: 'Confirmar'
  },
  cancelText: {
    type: String,
    default: 'Cancelar'
  },
  type: {
    type: String,
    default: 'warning',
    validator: (value) => ['warning', 'error', 'info', 'success'].includes(value)
  },
  persistent: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel'])

const loading = ref(false)

const icon = computed(() => {
  const icons = {
    warning: 'mdi-alert',
    error: 'mdi-alert-circle',
    info: 'mdi-information',
    success: 'mdi-check-circle'
  }
  return icons[props.type]
})

const iconColor = computed(() => {
  const colors = {
    warning: 'warning',
    error: 'error',
    info: 'info',
    success: 'success'
  }
  return colors[props.type]
})

const confirmColor = computed(() => {
  const colors = {
    warning: 'warning',
    error: 'error',
    info: 'primary',
    success: 'success'
  }
  return colors[props.type]
})

const handleConfirm = async () => {
  if (props.persistent) {
    loading.value = true
    try {
      await emit('confirm')
    } finally {
      loading.value = false
    }
  } else {
    emit('confirm')
    emit('update:modelValue', false)
  }
}

const handleCancel = () => {
  emit('cancel')
  emit('update:modelValue', false)
}
</script>

<style scoped>
.v-card-title {
  padding: 20px 24px 16px 24px;
}

.v-card-text {
  padding: 0 24px 16px 24px;
}
</style>
